import { render, staticRenderFns } from "./AppHeaderStart.vue?vue&type=template&id=2cb546d0&"
import script from "./AppHeaderStart.vue?vue&type=script&lang=js&"
export * from "./AppHeaderStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports